import { useState, useEffect } from 'react';
import { IListParams, IPaginationState } from "../types/common";
import qs from "qs";
import axios from "axios";
import { IListResponse } from "../types/api";
import { openConfirmModal } from "@mantine/modals";
import { showNotification } from "@mantine/notifications";
import { useNavigate } from "react-router-dom";
import { ITableInteractionParams } from "../components/table/types";

interface UseListPageConfig {
    apiRoute: string;
    clientRoute: string;
    customFetch?: (values: Partial<IListParams>) => void;
}

export const useListPage = <T>({
    apiRoute,
    clientRoute,
    customFetch
}: UseListPageConfig) => {

    const navigate = useNavigate();
    const [ records, setRecords ] = useState<T[]>([]);
    const [ paginationState, setPaginationState ] = useState<IPaginationState>({
        limit: 20,
        page: 1,
        totalDocuments: 1,
        totalPage: 1
    });

    useEffect(() => {
        void fetchData()
    }, []);

    const fetchData = async (values?: Partial<IListParams>) => {
        const params = {
            ...values,
            page: values?.page ?? paginationState.page,
            limit: values?.limit ?? paginationState.limit,
        }
        if (customFetch) {
            customFetch(params);
        } else {
            const { data } = await axios.post<IListResponse<T>>(`${apiRoute}/list`, params);
            setRecords(data?.result?.docs ?? []);
            setPaginationState({
                limit: data?.result?.limit,
                page: data.result.page,
                totalPage: data.result.totalPage,
                totalDocuments: data.result.totalDocumentCount
            })
        }
    }

    const deleteRecord = (id: string) => {
        openConfirmModal({
            title: 'Устгах',
            children: 'Мэдээлэл устгах уу?',
            labels: {
                confirm: 'Устгах',
                cancel: 'Цуцлах'
            },
            async onConfirm() {
                const { data } = await axios.delete(`${apiRoute}/${id}`);
                if (data.statusCode === 200) {
                    navigate(clientRoute);
                    void await fetchData();
                    showNotification({
                        title: 'Мэдэгдэл',
                        message: 'Амжилттай',
                        color: 'green'
                    })
                } else {
                    showNotification({
                        title: 'Мэдэгдэл',
                        message: 'Алдаа гарлаа',
                        color: 'red'
                    })
                }
            }
        });
    }

    const handleInteraction = (params: ITableInteractionParams) => {
        void fetchData({
            ...params,
            page: params.pageNumber,
            limit: params.pageSize,
        })
    }

    return {
        records,
        paginationState,
        fetchData,
        deleteRecord,
        handleInteraction,
        setRecords,
        setPaginationState
    }
}